// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:10:36

export default {
  "id": "sprunki-coloring-book",
  "slug": "sprunki-coloring-book",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c6a247522ac147a48c602cd87558dccc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c6a247522ac147a48c602cd87558dccc/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki Coloring Book",
      "description": "Dive into a colorful adventure with Sprunki Coloring Book, a delightful game designed for kids and adults alike. Choose from a wide variety of adorable Sprunki characters, captivating landscapes, and fun designs to color your way. Whether you're a budding artist or simply looking to relax, Sprunki Coloring Book offers endless possibilities for self-expression.\nStart coloring today and discover the joy of creativity with Sprunki Coloring Book!",
      "instructions": "Mouse Click",
      "genres": [
        "Art",
        "Educational"
      ],
      "tags": [
        "boys",
        "coloring",
        "drawing",
        "girls",
        "watercolor"
      ]
    },
    "zh-CN": {
      "title": "水滴涂色书",
      "description": "沉浸于Sprunki彩色画册的缤纷冒险中，这是一款专为儿童和成人设计的愉悦游戏。从众多可爱的Sprunki角色、迷人的风景和有趣的设计中选择，用彩色描绘你的世界。无论你是初露头角的艺术爱好者还是仅仅想放松心情，Sprunki彩色画册提供了无限的自我表达可能性。\n今天就开始上色吧，与Sprunki彩色画册一起发现创意的乐趣！",
      "instructions": "鼠标点击",
      "genres": [
        "艺术",
        "教育"
      ],
      "tags": [
        "boys",
        "上色，绘画，girls，水彩"
      ]
    },
    "zh-TW": {
      "title": "Sprunki 繪色書",
      "description": "深入一場多彩的冒險，與Sprunki 彩色繪本一同，這是一款適合孩子和大人共同享用的愉快遊戲。從眾多可愛的Sprunki 角色到迷人的風光，以及各種有趣的設計，讓你隨心所欲地彩繪。無論你是初露頭角的藝術家，還是只是想放鬆一下，Sprunki 彩色繪本都能為你帶來無窮的自我表達可能性。\n今起重啟彩繪之旅，與Sprunki 彩色繪本一探創意的樂趣！",
      "instructions": "滑鼠點擊",
      "genres": [
        "藝術",
        "教育"
      ],
      "tags": [
        "男孩們",
        "上色",
        "繪圖",
        "女孩們",
        "水彩"
      ]
    },
    "zh-HK": {
      "title": "Sprunki 填色冊",
      "description": "投入色彩旅程，與 Sprunki 彩色繪本一齊，一款適合兒童及成人的迷人遊戲。從多款可愛的 Sprunki 角色和迷人的風景，以及有趣的設計中選擇，盡情上色。無論你是潛在的藝術家還是只想放鬆心情，Sprunki 彩色繪本提供無限的自我表達可能性。\n今日開始上色，與 Sprunki 彩色繪本一齊探索創意的樂趣！",
      "instructions": "滑鼠點擊",
      "genres": [
        "藝術",
        "教育"
      ],
      "tags": [
        "男孩",
        "上色",
        "繪畫",
        "女孩",
        "水彩"
      ]
    },
    "ja": {
      "title": "スプリンキー塗り絵本",
      "description": "Sprunki Coloring Bookで色鮮やかな冒険に没頭しましょう。子どもや大人に合わせた魅力的なゲームです。可愛いSprunkiキャラクター、魅力的な風景、楽しいデザインから選んで、色を塗りましょう。アーティスト志望者やリラックスしたい方にも、Sprunki Coloring Bookは無限の表現の可能性を提供します。\n\n今日から色を塗り始めて、Sprunki Coloring Bookでクリエイティビティの喜びを発見しましょう！",
      "instructions": "マウスクリック",
      "genres": [
        "アート",
        "教育用"
      ],
      "tags": [
        "boys",
        "coloring",
        "drawing",
        "girls",
        "watercolor\n少年たち、塗り絵、絵を描く、少女たち、水彩画"
      ]
    },
    "ko": {
      "title": "스프런키 컬러링 북",
      "description": "스프띠키 컬러링 북을 통해 다채로운 모험에 뛰어들어 보세요. 어린이와 성인 모두를 위한 즐거운 게임입니다. 귀엽고 다양한 스프띠키 캐릭터, 매력적인 풍경, 그리고 그릴 수 있는 재미있는 디자인을 선택하세요. 예술가를 꿈꾸거나 plain relax하고 싶을 때, 스프띠키 컬러링 북은 끝없는 표현의 가능성을 제공합니다.\n오늘부터 컬러링을 시작하고 스프띠키 컬러링 북과 함께 창의성의 즐거움을 발견하세요!",
      "instructions": "마우스 클릭",
      "genres": [
        "아트",
        "교육적"
      ],
      "tags": [
        "아이들",
        "칠하기",
        "그리기",
        "소녀들",
        "수채화"
      ]
    },
    "fr": {
      "title": "Livre de coloriage Sprunki",
      "description": "Plongez dans une aventure colorée avec Sprunki Coloring Book, un jeu delightful conçu pour les enfants et les adultes. Choisissez parmi une large gamme de personnages Sprunki adorables, des paysages captivants et des designs fun pour colorier à votre guise. Que vous soyez un artiste en herbe ou simplement à la recherche de relaxation, Sprunki Coloring Book offre des possibilités infinies d'expression personnelle.\nCommencez à colorier dès aujourd'hui et découvrez le bonheur de la créativité avec Sprunki Coloring Book !",
      "instructions": "Clic de souris",
      "genres": [
        "Art",
        "Éducatif"
      ],
      "tags": [
        "garçons",
        "coloriage",
        "dessin",
        "filles",
        "aquarelle"
      ]
    }
  }
};
